import { useMutation, useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { PARTICIPANTS_KEYS } from "~/shared/api/participants/participants.queries";
import { UpdateRoleBody } from "~/shared/api/participants/participants.types";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export function useUpdateSavedRole(savedRoleId: number) {
  const { data: user } = useSuspenseQuery(USERS_QUERIES.profile());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateRoleBody) => {
      const response = await api.patch(`/participants/${user.id}/saved/roles/${savedRoleId}`, data);
      return response.data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: PARTICIPANTS_KEYS.savedRoles(user.id.toString()),
      });
    },
  });
}
